import { Box, Typography } from "@mui/material";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { renderModal } from "../handlers";
import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import FormEnviarPorEmail from "./FormEnviarPorEmail";

const Recibo = ({ recibo, setRecibo }) => {
  const [qrModalIsOpen, setQrModalIsOpen] = useState(false);
  const [sendEmailModalIsOpen, setSendEmailModalIsOpen] = useState(false);

  return (
    <Box>
      {recibo.pago && (
        <div className='d-block d-md-none alert alert-info fw-bold'>
          <p className='mb-0'>El recibo ya fue pagado</p>
        </div>
      )}
      <Box className='row mt-3'>
        <Box className='col-md-8'>
          <iframe src={recibo.recibo.base64?.recibo} height='650px' width='100%' id='pdf' title={"PDF Recibo"}></iframe>
        </Box>
        <Box className='col-md-4'>
          <Box className='card text-center'>
            <Box className='card-header text-center' style={{ backgroundColor: "#1365ae" }}>
              <span className='card-title fw-bold text-white'>RECIBO</span>
            </Box>
            <Box
              className='card-body text-center'
              style={{ border: "1px solid #1365ae", borderRadius: "0 0 0.375rem 0.375rem" }}
            >
              {recibo.pago ? (
                <div className='alert alert-info fw-bold'>
                  <p className='mb-0'>El recibo ya fue pagado</p>
                </div>
              ) : (
                <Typography className='mb-4'>Se generó el recibo de su acta</Typography>
              )}
              <Box className='btn-wrapper d-flex flex-column'>
                {recibo.recibo.qrLink ? (
                  <Button className='mb-2 w-100 border-none' onClick={() => setQrModalIsOpen(true)}>
                    <QrCodeIcon /> Pagar Online
                  </Button>
                ) : null}
                {/* <Button className="mb-2" onClick={() => setSendEmailModalIsOpen(true)}> <EmailIcon /> Enviar por email</Button> */}
                <Button className='btn btn-primary' onClick={() => setRecibo(null)}>
                  Volver
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
        {renderModal(
          qrModalIsOpen,
          setQrModalIsOpen,
          "Pagar Online",
          <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center'>
            <Box>
              <QRCodeSVG
                size='175'
                onClick={() => {
                  setQrModalIsOpen(false);
                }}
                value={recibo.recibo.qrLink}
              />
            </Box>
            <Typography className='mt-3 fw-bold'>
              Enlace directo:{" "}
              <a target='_blank' rel='noopener noreferrer' href={recibo.recibo.qrLink}>
                click aquí
              </a>
            </Typography>
          </Box>
        )}

        {/* {renderModal(sendEmailModalIsOpen, setSendEmailModalIsOpen, 'Enviar por Email', <FormEnviarPorEmail acta={acta} />)} */}
      </Box>
    </Box>
  );
};

export default Recibo;
